// extracted by mini-css-extract-plugin
export var container = "_f3-1";
export var cornerButtonContainer = "_f3-6";
export var disabled = "_f3-2";
export var dragActive = "_f3-3";
export var fileContainer = "_f3-5";
export var hiddenInput = "_f3-4";
export var widthContainer = "_f3-0";